import { IPagination, IPolicie } from "../types/policies.type";
import $http from "../services/AxiosInstance";
import saveAs from 'file-saver';

interface Params {
  page?: number,
  search?: string,
  startDate?: string,
  endDate?: string,
  company?: string | number,
  clientId?: string,
  certificateNumber?: string,
  typePolicyTransport?: string,
}

export interface getPoliciesResponse {
  policies: {
    policies?: IPolicie[]
    pagination?: IPagination
  }
}

const getBlobFile = async (url: string, params: URLSearchParams) => {
  const config = {
    params,
    responseType: 'blob' as const,
  };

  return await $http.get(url, config);
};

class PolicyRepository {
  async getPolicies(params: Params): Promise<getPoliciesResponse> {
    try {
      const response = await $http.get('/integrations/policyAll', { params });

      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }

  async getExcelPolicies({
    search,
    toExcel,
    startDate,
    endDate,
    company,
    clientId,
    certificateNumber,
    typePolicyTransport,
  }: {
    search?: string | null;
    toExcel: boolean;
    startDate: string | null;
    endDate: string | null;
    company: string | number | null;
    clientId?: string | null;
    certificateNumber?: string | null;
    typePolicyTransport?: string | null;
  }) {
    try {
      const params = new URLSearchParams();
      params.append('toExcel', String(toExcel));
      if (search && search.trim() !== '') {
        params.append('search', search);
      }
      params.append('startDate', startDate ?? 'null');
      params.append('endDate', endDate ?? 'null');
      params.append('company', company ? String(company) : 'null');
      if (clientId) params.append('clientId', String(clientId));
      if (certificateNumber?.trim()) {
        params.append('certificateNumber', certificateNumber.trim());
      }
      params.append('typePolicyTransport', typePolicyTransport ?? 'null');

      const { data } = await getBlobFile('/integrations/policyAll', params);

      saveAs(data, `Polizas.xlsx`);
    }
    catch (error) {
      return error;
    }
  }

  async downloadCertificatePdf(id: number) {
    try {
      const response = await $http.post(`/integrations/policy/pdf`, { id }, {
        responseType: 'blob',
      });

      saveAs(response.data, `Certificado-${id}.pdf`);
    } catch (error) {
      console.error('Error al descargar el certificado:', error);
    }
  }

  async deletePolicy(id: number, params: Params | null = null) {
    const response = await $http.delete(`/integrations/deletePolicy/${id}`, { params });
    return response.data;
  }
}

export default PolicyRepository;
